import { render, staticRenderFns } from "./noticeVisitors.vue?vue&type=template&id=fed25008&scoped=true"
import script from "./noticeVisitors.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeVisitors.vue?vue&type=script&setup=true&lang=js"
import style0 from "./noticeVisitors.vue?vue&type=style&index=0&id=fed25008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed25008",
  null
  
)

export default component.exports